import _ from 'lodash'
import { MutationTree } from 'vuex'

import { Order, OrderHistoryState, Page } from './types'

import { log } from '../../../log'

const namespace = 'orderHistory'

export const mutations: MutationTree<OrderHistoryState> = {

  addPage(state, payload: { page: Page }) {
    const { page } = payload
    state.error = {}
    state.pages = [
      ...state.pages.filter(p => p.pageNumber !== page.pageNumber),
      page,
    ]

    log.debug({ commit: `${namespace}/addPage`, state })
  },

  addErrorPage(state, payload: { pageNumber: number, error: Error }) {
    const { pageNumber, error } = payload
    state.pages = [
      ...state.pages.filter(p => p.pageNumber !== pageNumber),
      {
        pageNumber,
        items: [],
        isLastPage: false,
        error,
      },
    ]

    log.debug({ commit: `${namespace}/addErrorPage`, state })
  },

  get(state, payload: { order: Order }) {
    const { order } = payload
    state.error = {}
    state.item = order

    log.debug({ commit: `${namespace}/get`, state })
  },

  errorOnLoad(state, payload: Error) {
    const error = payload
    _.set(state, 'error.load', error)
  },
}
